export default "__VITE_ASSET__qHaVPoyP__"